<template>
  <div>
    <v-data-table
      @dblclick:row="showDetails"
      :loading-text="$t('appointment.table.loading')"
      :no-data-text="$t('appointment.table.noData')"
      :items-per-page="itemsPerPage"
      :items="defaultServiceValues"
      :loading="isLoading"
      :headers="headers"
      mobile-breakpoint="20"
      class="clickable"
      hide-default-footer
      disable-sort
    >
      <template v-slot:[`item.type`]="{ item }">
        <span class="mw-250 d-block text-truncate">
          {{ $t(`type.${item.type}`) }}
        </span>
      </template>
      <template v-slot:[`item.city`]="{ item }">
        {{ item.city ? item.city.name : '---' }}
      </template>
      <template v-slot:[`item.price`]="{ item }">
        {{ monetaryFormat(item.price) }}
      </template>
      <template v-slot:[`item.date_created`]="{ item }">
        {{ dateFormat(item.date_created) }}
      </template>
      <template v-slot:[`item.created_by`]="{ item }">
        {{ item.created_by ? item.created_by.name : '---' }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="showDefaultServiceValues(item.id)"
                v-bind="attrs"
                v-on="on"
                class="mr-2"
                icon
              >
                <v-icon small> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('defaultServiceValues.actions.visualize') }}
            </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="invalidateValue(item)"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon small> mdi-alert-circle-outline </v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t('defaultServiceValues.actions.inactivate') }}
            </span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <RightDrawer :title="drawerTitle" :moreInfo="false">
      <DefaultServiceValuesDetails />
    </RightDrawer>
  </div>
</template>

<script>
import RightDrawer from '@/components/app/RightDrawer'
import DefaultServiceValuesDetails from '../DefaultServiceValuesDetails'

import { mapGetters, mapMutations, mapActions } from 'vuex'

import { defaultServiceValuesHeaders } from './defaultServiceValuesHeaders'
import { catalogMonetary, catalogDateWithoutTime } from '@/util/catalog'

export default {
  name: 'DefaultServiceValuesTabsList',

  components: {
    RightDrawer,
    DefaultServiceValuesDetails,
  },

  data() {
    return {
      headers: defaultServiceValuesHeaders,
      dateFormat: catalogDateWithoutTime,
      monetaryFormat: catalogMonetary,
      drawerTitle: this.$t('defaultServiceValues.defaultServiceValuesDetails'),
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'itemsPerPage', 'defaultServiceValues']),
  },

  methods: {
    ...mapActions(['fetchDefaultServiceValue']),
    ...mapMutations(['setDefaultServiceValue', 'setIsDrawerOpen', 'openModal']),

    showDefaultServiceValues(id) {
      this.setIsDrawerOpen(true)
      this.fetchDefaultServiceValue(id)
    },

    invalidateValue(item) {
      this.setDefaultServiceValue(item)
      this.openModal('INVALIDATE_ITEM_DEFAULT_SERVICE_VALUES')
    },

    showDetails(_, { item }) {
      this.showDefaultServiceValues(item.id)
    },
  },
}
</script>
